import { api } from "../../services";
import { uiActions } from "../ui";

import {
  SET_WEEDS,
  ADD_CHECKED_WEED,
  REMOVE_CHECKED_WEED,
  CLEAR_WEEDS
} from "./types";

export const requestWeeds = (cropId, seasonId) => dispatch => {
  dispatch(uiActions.setLoading(true));
  return api
    .getWeeds(cropId, seasonId)
    .then(weeds => {
      dispatch(uiActions.setLoading(false));
      dispatch(recievedWeeds(weeds));
    })
    .catch(e => {
      dispatch(uiActions.setLoading(false));
      dispatch(uiActions.showMessage("Kunde inte hämta ogräs"));
    });
};

const recievedWeeds = weeds => {
  return {
    type: SET_WEEDS,
    payload: weeds
  };
};

export const setCheckedWeed = id => {
  return {
    type: ADD_CHECKED_WEED,
    payload: id
  };
};

export const setUncheckedWeed = index => {
  return {
    type: REMOVE_CHECKED_WEED,
    payload: index
  };
};

export const clearWeeds = () => {
  return {
    type: CLEAR_WEEDS
  };
}
